/**
 * Muñeca's MC monogram. Renders the real brand asset (public/munecas-mc.svg,
 * gold #C9A452). On dark backgrounds the gold reads fine; pass `invert` to
 * force white via filter when needed.
 */
export default function Monogram({
  className = "",
  invert = false,
}: {
  className?: string;
  invert?: boolean;
}) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/munecas-mc.svg"
      alt="Muñeca's Couture"
      width={51}
      height={28}
      className={className}
      style={invert ? { filter: "brightness(0) invert(1)" } : undefined}
    />
  );
}
